import React from "react";
import { useDispatch, useSelector } from "react-redux";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/RiskMembersSagas";

const OPTIONS = [
  { id: "critical", name: "Critical" },
  { id: "high", name: "High" },
  { id: "medium", name: "Medium" },
  { id: "low", name: "Low" }
];

const RiskFilter = () => {
  const dispatch = useDispatch();
  const selectedIds = useSelector((state) => state.riskMembers.riskLevels) || [];
  const selected = OPTIONS.filter((opt) => selectedIds.includes(opt.id));

  return (
    <MultiSelectDropdown
      options={OPTIONS}
      selectedFilters={selected}
      placeholder="Risk Level"
      numberDisplayed={1}
      multiple
      keepOpen
      includeFilter={false}
      includeSelectAll
      enableOnly
      enableOnlyText="Only"
      onSelectChange={(items) => {
        const next = (Array.isArray(items) ? items : [items])
          .filter(Boolean)
          .map((it) => it.id);
        // Don't allow an empty selection — fall back to Critical.
        dispatch(actionCreators.setRiskLevels(next.length ? next : ["critical"]));
      }}
    />
  );
};

export default RiskFilter;
